<!-- Filtering -->
<div class="sticky-header">
    <div class="p-10 p-r-20 p-l-20 p-t-20">
        <mat-form-field>
            <input matInput (keyup)="onInputChange($event.target.value)" placeholder="{{ 'filter' | translate }}"
                   [(ngModel)]="filterValue"/>
            <button mat-button *ngIf="filterValue" matSuffix mat-button aria-label="Clear"
                    (click)="onClearedSelected()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>
